module.exports = __webpack_public_path__ + "static/media/linkedin.ddfc37d6.svg";